var _linearGradient, _path, _linearGradient2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Nail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1uWcVf_3AKgwTcostLCsHa",
    x1: 21.384,
    x2: 25.997,
    y1: 4.211,
    y2: 7.48,
    gradientTransform: "rotate(45.001 23.5 27.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#1uWcVf_3AKgwTcostLCsHa)",
    d: "M43.42,18.015L29.985,4.58c-0.391-0.391-0.391-1.024,0-1.414l2.121-2.121 c0.391-0.391,1.024-0.391,1.414,0l13.435,13.435c0.391,0.391,0.391,1.024,0,1.414l-2.121,2.121 C44.444,18.405,43.811,18.405,43.42,18.015z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1uWcVf_3AKgwTcostLCsHb",
    x1: 21.494,
    x2: 21.427,
    y1: 5.799,
    y2: 18.202,
    gradientTransform: "rotate(45.001 23.5 27.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#484b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#66737e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#9fa7b0"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#1uWcVf_3AKgwTcostLCsHb)",
    points: "10.186,42.763 39.178,13.772 34.228,8.822 5.237,37.814 5.237,37.814 2.762,45.238 10.186,42.764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Nail);
export default __webpack_public_path__ + "static/media/icons8-nail.8c32c9058c4bc8c837e96e5233d39c69.svg";
export { ForwardRef as ReactComponent };